




















































































import { Component } from 'vue-mixin-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import ReCAPTCHA from '@/components/ReCAPTCHA.vue';
import ReCAPTCHABranding from '@/components/ReCAPTCHABranding.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import * as StringUtil from '@/common/StringUtil';
import * as Message from '@/common/Messages';
import { PASSWORD_LENGTH_MIN, PASSWORD_LENGTH_MAX } from '@/classification/KenteiDefinition';

import PasswordUpdateParam from '@/models/account/PasswordUpdateParam';

import RepositoryFactory from '@/repository/RepositoryFactory';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
      're-captcha-branding': ReCAPTCHABranding,
    },
  },
)
export default class UpdatePass extends BaseView {
  private reCAPTCHA = new ReCAPTCHA();

  private isIndicatorDisplay = false;

  private isUpdateFail = false;

  private invalidCurrentPassword = false;

  private invalidNewPassword = false;

  private invalidNewPasswordConfirm = false;

  private invalidPassword = false;

  private apiFailMsg = '';

  private currentPasswordErrMsg = '';

  private newPasswordErrMsg = '';

  private newPasswordConfirmErrMsg = '';

  private passwordErrMsg = '';

  private param = new PasswordUpdateParam();

  private msg = Message;

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * パスワード更新処理を行います。
   */
  private async passwordUpdate() {
    if (!this.validatePassword()) return;

    try {
      this.isIndicatorDisplay = true;

      // reCaptchaトークンの取得
      await this.reCAPTCHA.getToken('update_password').then((token: string) => {
        this.param.reCaptchaToken = token;
      });

      // パスワードの更新
      const AccountRepository = RepositoryFactory.get().account;
      await AccountRepository.passwordUpdate(this.param).then((response: any) => {
        if (response.status === 204) {
          this.$router.replace(this.paths.UPDATE_PASS_COMPLETE);
        } else {
          this.isUpdateFail = true;
          this.apiFailMsg = this.msg.UPDATE_PASSWORD_FAILURE;
        }
      }).catch((err) => {
        this.apiFailMsg = err.response.data.error;
        this.isUpdateFail = true;
      });
    } catch (e) {
      this.apiFailMsg = this.msg.UPDATE_PASSWORD_FAILURE;
      this.isUpdateFail = true;
    } finally {
      this.isIndicatorDisplay = false;
    }
  }

  /**
   * パスワードのValidateを行います。
   */
  private validatePassword() {
    let isValid = true;
    this.invalidCurrentPassword = false;
    this.invalidNewPassword = false;
    this.invalidNewPasswordConfirm = false;
    this.invalidPassword = false;
    this.currentPasswordErrMsg = '';
    this.newPasswordErrMsg = '';
    this.newPasswordConfirmErrMsg = '';
    this.passwordErrMsg = '';

    if (StringUtil.isEmpty(this.param.currentPassword)) {
      this.currentPasswordErrMsg = Message.REQUIRED_CURRENT_PASSWORD;
      this.invalidCurrentPassword = true;
      isValid = false;
    }

    if (String(this.param.currentPassword).length < PASSWORD_LENGTH_MIN || String(this.param.currentPassword).length > PASSWORD_LENGTH_MAX) {
      this.currentPasswordErrMsg = Message.PASSWORD_LENGTH;
      this.invalidCurrentPassword = true;
      isValid = false;
    }

    if (StringUtil.isEmpty(this.param.newPassword)) {
      this.newPasswordErrMsg = Message.REQUIRED_PASSWORD;
      this.invalidNewPassword = true;
      isValid = false;
    }

    if (String(this.param.newPassword).length < PASSWORD_LENGTH_MIN || String(this.param.newPassword).length > PASSWORD_LENGTH_MAX) {
      this.newPasswordErrMsg = Message.PASSWORD_LENGTH;
      this.invalidNewPassword = true;
      isValid = false;
    }

    if (StringUtil.isEmpty(this.param.newPasswordConfirm)) {
      this.newPasswordConfirmErrMsg = Message.REQUIRED_PASSWORD_CONFIRM;
      this.invalidNewPasswordConfirm = true;
      isValid = false;
    }

    if (!isValid) return isValid;

    // undefinedは無くなったのでStringにキャスト
    const newPassword = String(this.param.newPassword);
    const newPasswordConfirm = String(this.param.newPasswordConfirm);

    if (newPassword !== newPasswordConfirm) {
      this.passwordErrMsg = Message.NEW_PASSWORD_MISMATCH;
      this.invalidPassword = true;
      isValid = false;
      return isValid;
    }

    if (newPassword.length < PASSWORD_LENGTH_MIN || newPassword.length > PASSWORD_LENGTH_MAX) {
      this.newPasswordErrMsg = Message.PASSWORD_LENGTH;
      this.invalidNewPassword = true;
      isValid = false;
    }

    if (newPasswordConfirm.length < PASSWORD_LENGTH_MIN || newPasswordConfirm.length > PASSWORD_LENGTH_MAX) {
      this.newPasswordConfirmErrMsg = Message.PASSWORD_LENGTH;
      this.invalidNewPasswordConfirm = true;
      isValid = false;
    }

    if (!isValid) return isValid;

    if (!UpdatePass.passwordRegxCheck(newPassword)) {
      this.invalidNewPassword = true;
      this.newPasswordErrMsg = Message.PASSWORD_STRING_TYPE;
      isValid = false;
    }

    return isValid;
  }

  static passwordRegxCheck(password: string) {
    const isIncludeUppercase = password.match('[A-Z]') !== null;
    const isIncludeLowercase = password.match('[a-z]') !== null;
    const isIncludeNumericOrSymbol = password.match('[0-9]|[!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~]') !== null;
    const isIncludeDoubleByte = password.match('[^\x01-\x7E]') !== null;
    if (!isIncludeUppercase || !isIncludeLowercase || !isIncludeNumericOrSymbol || isIncludeDoubleByte) {
      return false;
    }
    return true;
  }
}
